module["exports"] = [
  "box.az",
  "mail.az",
  "gmail.com",
  "yahoo.com",
  "hotmail.com"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/az/internet/free_email.js
// module id = 186
// module chunks = 0